import Button from "@/components/core/Button/Button"

const FeedbackFromConfirmation = props => {
  const { staticText, handleResetData, resetTab } = props

  return (
    <div className="customer-support-feedback__success-box">
      <div className="customer-support-feedback__success-description">
        {staticText?.feedbackMessageSuccess}
      </div>
      <div className="container">
        <Button
          className={"customer-support-feedback__success-button"}
          role="button"
          onClick={() => {
            handleResetData()
            resetTab()
          }}
          type="black"
          label={staticText?.backToCustomerSupport}
          flexible
        />
      </div>
    </div>
  )
}

export default FeedbackFromConfirmation
